import React, { Component } from 'react'
import './App.css'
import Landing from './components/Landing'
import CustomCookieBanner from './components/CustomCookieBanner'
import PopInExpiration from './components/PopInExpiration'
import WhatsAppBubble from './components/WhatsAppBubble'
import { Cookies } from 'react-cookie-banner'
import { ParallaxProvider } from 'react-scroll-parallax'
import { injectIntl } from "react-intl"
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import { API_ROOT } from './api-config'
import axios from 'axios'
import { isIE } from 'react-device-detect'

const cookies = new Cookies()

const asyncComponent = (loadComponent) => {
  return class AsyncComponent extends Component {
    state = {
      Component: null
    }

    componentDidMount() {
      loadComponent().then((module) => {
        this.setState({ Component: module.default || module })
      })
    }

    render() {
      const LoadedComponent = this.state.Component
      return LoadedComponent ? <LoadedComponent {...this.props} /> : null
    }
  }
}

const Booking = asyncComponent(() => import('./components/Booking'))
const CartContainer = asyncComponent(() => import('./components/CartContainer'))
const LostAsylum = asyncComponent(() => import('./components/LostAsylum'))
const VeryBadNight = asyncComponent(() => import('./components/VeryBadNight'))
const Abattoir = asyncComponent(() => import('./components/Abattoir'))
const Yakuza = asyncComponent(() => import('./components/Yakuza'))
const Tombeau = asyncComponent(() => import('./components/Tombeau'))
const TeamBuilding = asyncComponent(() => import('./components/TeamBuilding'))
const HorrorEscapeGame = asyncComponent(() => import('./components/HorrorEscapeGame'))
const HalloweenEscapeGame = asyncComponent(() => import('./components/HalloweenEscapeGame'))
const EscapeGameTwoPlayers = asyncComponent(() => import('./components/EscapeGameTwoPlayers'))
const FirstEscapeGameParis = asyncComponent(() => import('./components/FirstEscapeGameParis'))
const ChristmasGiftEscapeGame = asyncComponent(() => import('./components/ChristmasGiftEscapeGame'))
const ProductionRental = asyncComponent(() => import('./components/ProductionRental'))
const HolidayVouchers = asyncComponent(() => import('./components/HolidayVouchers'))
const CorporateGiftVoucher = asyncComponent(() => import('./components/CorporateGiftVoucher'))
const Pricing = asyncComponent(() => import('./components/Pricing'))
const BachelorPartyEscapeGame = asyncComponent(() => import('./components/BachelorPartyEscapeGame'))
const BachelorettePartyEscapeGame = asyncComponent(() => import('./components/BachelorettePartyEscapeGame'))
const SiteMapPage = asyncComponent(() => import('./components/SiteMapPage'))
const BestEscapeGameParis = asyncComponent(() => import('./components/BestEscapeGameParis'))
const BirthdayEscapeGame = asyncComponent(() => import('./components/BirthdayEscapeGame'))
const TeenEscapeGameParis = asyncComponent(() => import('./components/TeenEscapeGameParis'))
const YouthGroupsPage = asyncComponent(() => import('./components/YouthGroupsPage'))
const OriginalOutingParis = asyncComponent(() => import('./components/OriginalOutingParis'))
const ScariestEscapeGame = asyncComponent(() => import('./components/ScariestEscapeGame'))
const ActorsEscapeGameParis = asyncComponent(() => import('./components/ActorsEscapeGameParis'))
const CancellationPolicy = asyncComponent(() => import('./components/CancellationPolicy'))
const VeryBadNightCustomizationPage = asyncComponent(() => import('./components/VeryBadNightCustomizationPage'))
const PackVideoPage = asyncComponent(() => import('./components/PackVideoPage'))
const BirthdayOptionPage = asyncComponent(() => import('./components/BirthdayOptionPage'))
const ContactPage = asyncComponent(() => import('./components/ContactPage'))
const RecruitmentPage = asyncComponent(() => import('./components/RecruitmentPage'))
const PressPage = asyncComponent(() => import('./components/PressPage'))
const RoomChoicePage = asyncComponent(() => import('./components/RoomChoicePage'))
const EscapeGameAwardsPage = asyncComponent(() => import('./components/EscapeGameAwardsPage'))
const LegalNoticePage = asyncComponent(() => import('./components/LegalNoticePage'))
const TermsOfSalePage = asyncComponent(() => import('./components/TermsOfSalePage'))
const GameDesignPage = asyncComponent(() => import('./components/GameDesignPage'))
const FAQ = asyncComponent(() => import('./components/FAQ'))
const GiftCard = asyncComponent(() => import('./components/GiftCard'))
const GoodiesProductPage = asyncComponent(() => import('./components/GoodiesProductPage'))
const GoodiesCartPage = asyncComponent(() => import('./components/GoodiesCartPage'))
const Confirmation = asyncComponent(() => import('./components/Confirmation'))
const Payment = asyncComponent(() => import('./components/Payment'))
const NotFound = asyncComponent(() => import('./components/NotFound'))

const buildAPI_URL = (idOrder, tokenOrder) => {
  return `${API_ROOT}FrontGetOrderDetails.php?id_order=${idOrder}&token_order=${tokenOrder}`
}

const buildFormBody = (body) => {
  let formBody = []

  for (let property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&")

  return formBody
}

class App extends Component {
  constructor(props) {
    super(props)
    this.state={
      showCookieBanner: false,
      showPopInExpiration: false,
      timeLeft: 0,
      needMoreTime: false,
      appKey: 1
    }
  }

  getPrices = async (list, html = true) => {
    try {
      const response = await axios.get(`${API_ROOT}GetCompanyPrices.php`);
      let output = "<ul>";
      list.forEach(element => {
        const price = parseInt(response.data["prix" + element + "j"]);
        output += "<li>" + element + " personnes: " + price + "&euro; soit " + parseInt(price / element) + "&euro; par personne</li>";
      });
      output += "<ul>";
      if (html)
        return output;
      else
        return response.data;
    } catch (error) {
      console.error("Error while loading prices :", error);
      return null;
    }
  };

  triggerPopInExpiration = async () => {
    const cookies = new Cookies()
    const orderDetails = cookies.get("orderDetails")
    const expiracyValue = orderDetails && orderDetails.order_details && orderDetails.order_details.expiracy ? orderDetails.order_details.expiracy : orderDetails && orderDetails.expiracy
    if (expiracyValue) {
      const expiracy = expiracyValue * 1000
      const timeLeft = new Date(expiracy) - new Date().getTime()
      // for testing
      // const timeLeft = 10000 * 1
      const minutesBeforeWarning = 9
      const warning = 60000 * minutesBeforeWarning
      const timeBeforeWarning = timeLeft - warning
      this.currentExpiration = expiracy
      if (timeBeforeWarning > 0) {
        setTimeout(() => {
          const currentOrderDetails = cookies.get("orderDetails")
          if (currentOrderDetails != null && (currentOrderDetails["order_details"] || currentOrderDetails.expiracy)) {
            this.setState({
              showPopInExpiration: true,
              timeLeft: timeLeft,
              needMoreTime: false
            })
          }
        }, timeBeforeWarning)
        setTimeout(async () => {
          if (!this.state.needMoreTime && this.currentExpiration === expiracy) {
            this.resetCart()
          }
        }, timeLeft)
      }
    }
  }

  resetCart = async (disableDeleteAllBookings = false) => {
    this.setState({
      showPopInExpiration: false,
    })
    console.log("time is up")
    const cookies = new Cookies()
    let bookings = cookies.get("bookings")
    if (bookings && !disableDeleteAllBookings) {
      this.deleteAllBookings()
    }

    bookings = []
    cookies.set('bookings', bookings, { path: '/', expires: new Date('2020-12-17T03:24:00') })
    cookies.set('cart_step', 0, { path: '/', expires: new Date('2020-12-17T03:24:00') })

    if (!window.location.href.indexOf("confirmation") > 0) {
      this.setState({ appKey: this.state.appKey + 1})
    }
  }

  getOrderInfo = async () => {
    const cookies = new Cookies()
    const idOrder = cookies.get('orderDetails').id_order_escape
    const tokenOrder = cookies.get('orderDetails').id_order_escape_token
    axios.get(buildAPI_URL(idOrder, tokenOrder))
      .then(response => {
        if (!response.data.result || (response.data.result && response.data.rooms && response.data.rooms.length == 0)) {
          this.resetCart(true)
          const cookies = new Cookies()
          cookies.remove("orderDetails")
          cookies.remove("bookings")
          cookies.remove("bookingsTokens")
          this.setState({ appKey: this.state.appKey + 1})
        } else {
          const cookies = new Cookies()
          let orderDetails = cookies.get("orderDetails")
          orderDetails.order_details = response.data
          cookies.set('orderDetails', orderDetails, { path: '/', expires: new Date('2040-12-17T03:24:00') })
          this.triggerPopInExpiration()
        }
      })
      .catch(error => {
        const cookies = new Cookies()
        cookies.remove("orderDetails")
        cookies.remove("bookings")
        cookies.remove("bookingsTokens")
        this.setState({ appKey: this.state.appKey + 1})
        console.log(error)
      })
  }

  deleteAllBookings = async () => {
    const cookies = new Cookies()
    const bookings = cookies.get("bookings")
    const tokens = cookies.get("bookingsTokens")
    const url = `${API_ROOT}FrontDeleteRoomReservation.php`

    bookings.forEach( async (booking) => {
      let token = tokens.find(x => x.id_room_reservation.toString() === booking.id)

      const body = {
        id_reservation: booking.id.toString(),
        token_reservation: token.id_room_reservation_token
      }

      return await fetch(url, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
        method: 'post',
        body: buildFormBody(body)
      })
      .then(async (response) => response.json())
      .then(async (data) => {
        console.log(data)
        if (data.result === false) {
          const cookies = new Cookies()
          cookies.remove("orderDetails")
          cookies.remove("bookings")
          cookies.remove("bookingsTokens")
          console.log("done")
        }
        this.setState({ appKey: this.state.appKey + 1})
      })
      .catch(error => console.log(error))
    })
  }

  giveMoreTime = async () => {
    this.setState({
      showPopInExpiration: false,
      needMoreTime: true
    })
    try {
      await this.getOrderInfo()
    } catch (error) {
      console.error("Error while extending booking time:", error)
    }
  }

  closeBanner = () => {
    cookies.set('onehour', 'acceptedCookies', { path: '/', expires: new Date('2020-12-17T03:24:00') })
    this.setState({ showCookieBanner: false})
  }

  checkCart = () => {
    const cookies = new Cookies()
    let orderDetails = cookies.get("orderDetails")
    if (orderDetails) {
      this.getOrderInfo()
    }
  }

  componentDidMount() {
    const hasAcceptedCookies = Object.keys(cookies.getAll()).length !== 0

    if (!hasAcceptedCookies) {
      this.setState({ showCookieBanner: true })
    }
    this.checkCart()
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    if (isIE) return <div> Internet Explorer n'est pas supporté. Essayez avec Chrome/Opera/Firefox.</div>
    return (
      <div className="App" key={this.state.appKey}>
        <ParallaxProvider>
          <Switch>
            <Route exact path="/" render={() =>
              <Landing
                lang={this.props.lang}
                handleLang={(lang) => this.props.handleLang(lang)}
                handleExpiration={() => this.triggerPopInExpiration()}
              />}
            />
            <Route exact path="/reserver" render={() =>
              <Booking
                lang={this.props.lang}
                handleExpiration={() => this.triggerPopInExpiration()}
                getPrices={(list, html) => this.getPrices(list, html)}
              />}
            />
            <Route exact path="/cart" render={() =>
                <CartContainer
                lang={this.props.lang}
                handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/lost-asylum" render={() =>
                <LostAsylum
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/very-bad-night" render={() =>
                <VeryBadNight
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/abattoir" render={() =>
                <Abattoir
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/yakuza" render={() =>
                <Yakuza
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/expedition-maudite" render={() =>
                <Tombeau
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/team-building" render={() =>
                <TeamBuilding
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  getPrices={(list, html) => this.getPrices(list, html)}
                />}
            />
            <Route exact path={["/escape-game-horreur", "/escape-game-horreur/"]} render={() =>
                <HorrorEscapeGame
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/escape-game-halloween-paris", "/escape-game-halloween-paris/"]} render={() =>
                <HalloweenEscapeGame
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/escape-game-deux-joueurs", "/escape-game-deux-joueurs/"]} render={() =>
                <EscapeGameTwoPlayers
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/premier-escape-game-paris", "/premier-escape-game-paris/"]} render={() =>
                <FirstEscapeGameParis
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/cadeau-noel-escape-game", "/cadeau-noel-escape-game/"]} render={() =>
                <ChristmasGiftEscapeGame
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/location-decor-tournage", "/location-decor-tournage/"]} render={() =>
                <ProductionRental
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/cheque-vacances-escape-game-paris", "/cheque-vacances-escape-game-paris/"]} render={() =>
                <HolidayVouchers
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/escape-game-coupon-cadeau-entreprise", "/escape-game-coupon-cadeau-entreprise/"]} render={() =>
                <CorporateGiftVoucher
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/nos-tarifs", "/nos-tarifs/"]} render={() =>
                <Pricing
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  getPrices={(list, html) => this.getPrices(list, html)}
                />}
            />
            <Route exact path={["/enterrement-de-vie-de-garcon-escape-game", "/enterrement-de-vie-de-garcon-escape-game/"]} render={() =>
                <BachelorPartyEscapeGame
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/enterrement-de-vie-de-jeune-fille-escape-game", "/enterrement-de-vie-de-jeune-fille-escape-game/"]} render={() =>
                <BachelorettePartyEscapeGame
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/plan-du-site", "/plan-du-site/"]} render={() =>
                <SiteMapPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/quel-est-le-meilleur-escape-game-de-paris", "/quel-est-le-meilleur-escape-game-de-paris/"]} render={() =>
                <BestEscapeGameParis
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/escape-game-anniversaire", "/escape-game-anniversaire/"]} render={() =>
                <BirthdayEscapeGame
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/escape-game-ado-paris", "/escape-game-ado-paris/"]} render={() =>
                <TeenEscapeGameParis
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/escape-game-centres-loisirs-groupes-jeunes-paris", "/escape-game-centres-loisirs-groupes-jeunes-paris/"]} render={() =>
                <YouthGroupsPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/sortie-originale-a-paris", "/sortie-originale-a-paris/"]} render={() =>
                <OriginalOutingParis
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/escape-game-le-plus-effrayant", "/escape-game-le-plus-effrayant/"]} render={() =>
                <ScariestEscapeGame
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/escape-game-avec-acteurs-paris", "/escape-game-avec-acteurs-paris/"]} render={() =>
                <ActorsEscapeGameParis
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/conditions-annulation", "/conditions-annulation/"]} render={() =>
                <CancellationPolicy
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/personnalisation-very-bad-night", "/personnalisation-very-bad-night/"]} render={() =>
                <VeryBadNightCustomizationPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/pack-video", "/pack-video/"]} render={() =>
                <PackVideoPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/option-anniversaire", "/option-anniversaire/"]} render={() =>
                <BirthdayOptionPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/contact", "/contact/"]} render={() =>
                <ContactPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/recrutement", "/recrutement/"]} render={() =>
                <RecruitmentPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/presse", "/presse/"]} render={() =>
                <PressPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/quelle-salle-one-hour-choisir", "/quelle-salle-one-hour-choisir/"]} render={() =>
                <RoomChoicePage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path={["/recompenses-escape-game", "/recompenses-escape-game/"]} render={() =>
                <EscapeGameAwardsPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/mentions-legales", "/mentions-legales/"]} render={() =>
                <LegalNoticePage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/conditions-generales-de-vente", "/conditions-generales-de-vente/"]} render={() =>
                <TermsOfSalePage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/gamedesign-creation-de-live-escape-game", "/gamedesign-creation-de-live-escape-game/"]} render={() =>
                <GameDesignPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/faq", "/faq/"]} render={() =>
                <FAQ
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/carte-cadeaux", "/carte-cadeaux/"]} render={() =>
                <GiftCard
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  getPrices={(list, html) => this.getPrices(list, html)}
                />}
            />
            <Route exact path={["/pack-goodies", "/pack-goodies/"]} render={() =>
                <GoodiesProductPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path={["/pack-goodies/panier", "/pack-goodies/panier/"]} render={() =>
                <GoodiesCartPage
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Route exact path="/confirmation" render={() =>
                <Confirmation
                />}
            />
            <Route exact path="/payment" render={() =>
              <Payment
              />}
            />
            <Route exact path="/404" render={() =>
                <NotFound
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Redirect to="/404" />
          </Switch>
          { this.state.showCookieBanner
            ? <CustomCookieBanner acceptCookies={this.closeBanner}/>
            : null
          }
        </ParallaxProvider>
        <WhatsAppBubble />
        {
          this.state.showPopInExpiration
          ? <PopInExpiration
              timeLeft={this.state.timeLeft}
              closePopIn={() => this.setState({ showPopInExpiration: false })}
              giveMeTime={() => this.giveMoreTime()}
            />
          : null
        }
      </div>
    );
  }
}

export default withRouter(injectIntl(App))



// WEBPACK FOOTER //
// ./src/App.js